export default __webpack_public_path__ + "static/media/login-bg.569e7e8d.webp";